/**
 * Feriados que tiram um dia útil do mês (usados no ritmo e na projeção).
 *
 * Aqui: os feriados nacionais de 2026 e 2027. Carnaval e Corpus Christi são
 * ponto facultativo e ficaram de fora (regra H do questionário).
 * Feriado municipal, ponte ou dia sem expediente: a gerente cadastra na tela
 * Cadastros → Feriados (vem da API em cadastros.feriados) e `juntarFeriados`
 * soma tudo.
 *
 * Lê: nada.
 * Usado por: dominio/dias-uteis.ts (pelas telas, através de dominio/painel.ts).
 */
import type { Feriado } from './tipos.ts';

export const FERIADOS: readonly Feriado[] = [
  { data: '2026-01-01', nome: 'Confraternização Universal' },
  { data: '2026-04-03', nome: 'Sexta-feira Santa' },
  { data: '2026-04-21', nome: 'Tiradentes' },
  { data: '2026-05-01', nome: 'Dia do Trabalho' },
  { data: '2026-09-07', nome: 'Independência do Brasil' },
  { data: '2026-10-12', nome: 'Nossa Senhora Aparecida' },
  { data: '2026-11-02', nome: 'Finados' },
  { data: '2026-11-15', nome: 'Proclamação da República' },
  { data: '2026-11-20', nome: 'Dia Nacional de Zumbi e da Consciência Negra' },
  { data: '2026-12-25', nome: 'Natal' },
  { data: '2027-01-01', nome: 'Confraternização Universal' },
  { data: '2027-03-26', nome: 'Sexta-feira Santa' },
  { data: '2027-04-21', nome: 'Tiradentes' },
  { data: '2027-05-01', nome: 'Dia do Trabalho' },
  { data: '2027-09-07', nome: 'Independência do Brasil' },
  { data: '2027-10-12', nome: 'Nossa Senhora Aparecida' },
  { data: '2027-11-02', nome: 'Finados' },
  { data: '2027-11-15', nome: 'Proclamação da República' },
  { data: '2027-11-20', nome: 'Dia Nacional de Zumbi e da Consciência Negra' },
  { data: '2027-12-25', nome: 'Natal' },
];

/** Os feriados como conjunto de datas, que é o formato que as contas usam. */
export const DATAS_FERIADOS: ReadonlySet<string> = new Set(FERIADOS.map((f) => f.data));

/** Nacionais + os cadastrados na tela, como conjunto de datas (o que as contas usam). */
export function juntarFeriados(extras: readonly Feriado[] = []): ReadonlySet<string> {
  return extras.length === 0 ? DATAS_FERIADOS : new Set([...DATAS_FERIADOS, ...extras.map((f) => f.data)]);
}
